import { z } from "zod";

export const stripeInvoicesPathFromAccount = "stripeInvoices";

// Stripe objects created before the account rename carry `projectId`; keep the key.
export const StripeMetadataSchema = z.object({
  projectId: z.string(),
});
export const StripeMetadataLooseSchema = z.looseObject({
  ...StripeMetadataSchema.shape,
});
export type StripeMetadata = z.infer<typeof StripeMetadataSchema>;

export const StripeCustomerSchema = z.object({
  id: z.string(),
  email: z.email().nullish(),
  name: z.string().nullish(),
  invoice_settings: z.object({
    default_payment_method: z.string().nullish(),
  }),
  metadata: StripeMetadataSchema,
});
export const StripeCustomerLooseSchema = z.looseObject({
  ...StripeCustomerSchema.shape,
  invoice_settings: z.looseObject({
    default_payment_method: z.string().nullish(),
  }),
  metadata: StripeMetadataLooseSchema,
});
export type StripeCustomer = z.infer<typeof StripeCustomerSchema>;

export const StripeSubscriptionSchema = z.object({
  id: z.string(),
  customer: z.string(),
  metadata: StripeMetadataSchema,
  status: z.enum([
    "active",
    "canceled",
    "incomplete",
    "incomplete_expired",
    "past_due",
    "paused",
    "trialing",
    "unpaid",
  ]),
});
export const StripeSubscriptionLooseSchema = z.looseObject({
  ...StripeSubscriptionSchema.shape,
  metadata: StripeMetadataLooseSchema,
});
export type StripeSubscription = z.infer<typeof StripeSubscriptionSchema>;

export const StripeInvoiceSchema = z.object({
  id: z.string(),
  customer: z.string(),
  status: z.enum(["draft", "open", "paid", "uncollectible", "void"]),
  amount_due: z.number(),
  amount_remaining: z.number(),
  created: z.number(), // Unix seconds
  effective_at: z.number().nullish(), // Unix seconds
  currency: z.string(),
  parent: z.object({
    subscription_details: z.object({
      metadata: StripeMetadataSchema,
      subscription: z.string(),
    }),
  }),
});
export const StripeInvoiceLooseSchema = z.looseObject({
  ...StripeInvoiceSchema.shape,
  parent: z.looseObject({
    subscription_details: z.looseObject({
      metadata: StripeMetadataLooseSchema,
      subscription: z.string(),
    }),
  }),
});
export type StripeInvoice = z.infer<typeof StripeInvoiceSchema>;
